import { Filter } from 'iconoir-react'
import MainLayout from '../layouts/MainLayout'
import { memo, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { useTheme } from '@mui/material'
import InternalConnectedDocumentPage from './InternalConnectedDocumentPage'
import { InternalConnectedDocumentOutgoing } from '../modules/InternalConnectedDocumentOutgoing'
import SearchAdvance from '../modules/InternalConnectedDocumentOutgoing/SearchAdvanceModal'

const InternalConnectedDocumentOutoingPage = () => {
  const [openSearchAdvance, setOpenSearchAdvance] = useState(false)
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    keyword: null,
    fromOutgoingDate: null,
    toOutgoingDate: null,
  })
  const theme = useTheme()
  return (
    <div style={{ background: theme.background.base, minHeight: '850px' }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px]"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <div className="font-bold text-[28px] leading-[29px]  ">
          VBLT nội bộ
        </div>
        <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenSearchAdvance(true)
          }}>
          <Filter />
        </span>
      </div>
      <MainLayout>
        <div className="px-2">
          <InternalConnectedDocumentPage valueInit={1} />
          <InternalConnectedDocumentOutgoing advFilter={filter} />
        </div>
        <SearchAdvance
          openSearchAdvance={openSearchAdvance}
          handleOpenSearchAdvance={() => {
            setOpenSearchAdvance(true)
          }}
          handleCloseSearchAdvance={() => {
            setOpenSearchAdvance(false)
          }}
          setFilter={setFilter}
          filter={filter}
        />
      </MainLayout>
    </div>
  )
}

export default memo(
  inject('aclStore')(observer(InternalConnectedDocumentOutoingPage))
)
